import i18n from '@/i18n/index.js'

const IMPORT_FAIL_REASON_KEY_BY_ZH = {
  '录入失败,车型名称重复!': 'importFailReason.name1',
  '录入失败,车型编号不能为空!': 'importFailReason.name2',
  '录入失败,车辆合格证照片不能为空!': 'importFailReason.name3',
  '输入失败, 车架号不能为空!': 'importFailReason.name4',
  '输入失败,, mac不能为空!': 'importFailReason.name5',
  '输入失败,MAC地址不能为空!': 'importFailReason.name6',
  '输入失败,iot 编号不能为空!': 'importFailReason.name8',
  '输入失败,iot已绑定整车!': 'importFailReason.name9',
  '输入失败,iot未入库!': 'importFailReason.name10',
  'Input failed, battery number cannot be empty!': 'importFailReason.name39',
  '输入失败,iot编号不能为空!': 'importFailReason.name11',
  '输入失败,中国强制性产品认证（CCC）证书编号不能为空!': 'importFailReason.name13',
  '输入失败,产品名称不能为空!': 'importFailReason.name14',
  '输入失败,充电器型号超过100个字符!': 'importFailReason.name15',
  '输入失败,充电器执行标准超过100个字符!': 'importFailReason.name16',
  '输入失败,充电器唯一性编号不能为空!': 'importFailReason.name70',
  'Input failed, charger unique ID cannot be empty!': 'importFailReason.name70',
  '输入失败,充电器厂家不能为空!': 'importFailReason.name71',
  'Input failed, charger manufacturer cannot be empty!': 'importFailReason.name71',
  '输入失败,充电器唯一性编号已存在!': 'importFailReason.name72',
  'Input failed, charger unique ID already exists!': 'importFailReason.name72',
  '输入失败,充电器厂家超过255个字符!': 'importFailReason.name73',
  'Input failed, charger manufacturer exceeds 255 characters!': 'importFailReason.name73',
  '输入失败,制造商或商标不能为空!': 'importFailReason.name17',
  '输入失败,制造日期格式错误!格式为yyyy-MM-dd!': 'importFailReason.name18',
  '输入失败,前后轮中心距不能为空!': 'importFailReason.name19',
  '输入失败,建议使用寿命不能为空!': 'importFailReason.name20',
  '输入失败,控制器编号不能为空!': 'importFailReason.name21',
  '输入失败,数据库输入失败!': 'importFailReason.name22',
  '输入失败,整车不能为空!': 'importFailReason.name24',
  '输入失败,整车信息不存在!': 'importFailReason.name25',
  '输入失败,整车编号已存在!': 'importFailReason.name26',
  '输入失败,模型不能为空!': 'importFailReason.name27',
  '输入失败,物联网不存在!': 'importFailReason.name28',
  '输入失败,物联网编号不能为空!': 'importFailReason.name29',
  '输入失败,物联网编号没有车辆信息!': 'importFailReason.name31',
  '输入失败,生产工厂和地址不能为空!': 'importFailReason.name32',
  '输入失败,生产日期/制造日期不能为空!': 'importFailReason.name33',
  '输入失败,生产日期/制造日期不能为空或格式错误!格式为yyyy-MM-dd!': 'importFailReason.name34',
  '输入失败,电机功率和额定电压不能为空!': 'importFailReason.name35',
  '输入失败,电机编号不能为空!': 'importFailReason.name36',
  '输入失败,电池类型不能为空!': 'importFailReason.name38',
  '输入失败,电池编号不能为空!': 'importFailReason.name39',
  '输入失败,证书信息已更改!': 'importFailReason.name40',
  '输入失败,证书截止日期格式错误!格式为yyyy-MM-dd!': 'importFailReason.name41',
  '输入失败,证书过期日期格式错误!格式为yyyy-MM-dd!': 'importFailReason.name42',
  '输入失败,该车辆已绑定至另一份合格证书!': 'importFailReason.name43',
  '输入失败,请勿修改其他制造商的车辆信息!': 'importFailReason.name44',
  '输入失败,车型名称不能为空!': 'importFailReason.name45',
  '输入失败,车型已存在!': 'importFailReason.name46',
  '输入失败,车型编号不能为空!': 'importFailReason.name47',
  '输入失败,车型编号重复!': 'importFailReason.name49',
  '输入失败,车架号不能为空!': 'importFailReason.name50',
  '输入失败,车辆代码不能为空!': 'importFailReason.name51',
  '输入失败,车辆代码重复!': 'importFailReason.name52',
  '输入失败,车辆信息不存在!': 'importFailReason.name53',
  '输入失败,车辆合格证不能为空!': 'importFailReason.name54',
  '输入失败,车辆型号和名称与预设数据不匹配!': 'importFailReason.name56',
  '输入失败,车辆编号不能为空!': 'importFailReason.name57',
  '输入失败,车辆编号重复!': 'importFailReason.name59',
  '输入失败,车辆编码不能为空!': 'importFailReason.name60',
  '输入失败,车辆编码位置不能为空!': 'importFailReason.name61',
  '输入失败,车辆编码重复!': 'importFailReason.name62',
  '输入失败,铭牌固定位置不能为空!': 'importFailReason.name63',
  '输入失败,长宽高不能为空!': 'importFailReason.name64',
  '输入失败,驾驶模式不能为空!': 'importFailReason.name65',
  '这些数据已经输入到数据库中,无需再次输入!': 'importFailReason.name66',
  'Input failed, cannot modify this IoT information!': 'importFailReason.name67',
  '这些数据已经输入到数据库中,无需重新输入!': 'importFailReason.name68',
  'Allocation successful!': 'importFailReason.name69',
}

const MAC_MISMATCH_PATTERN = /^输入失败,(.+)车辆已存在,但MAC地址不匹配!$/
const MAC_MISMATCH_PATTERN_ALT = /^输入错误,(.+)车辆已存在,MAC地址不匹配!$/
const UPLOAD_FILE_SIZE_PATTERN = /^The maximum allowed file upload is\s*(\d+)\s*G, with a current file size of\s*([0-9.]+)\s*G$/

function normalizeImportFailReasonText (message) {
  if (!message || typeof message !== 'string') return ''
  return message
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
}

export { normalizeImportFailReasonText }

export function translateImportFailReason (message) {
  if (!message || typeof message !== 'string') return message
  const trimmed = normalizeImportFailReasonText(message)
  const key = IMPORT_FAIL_REASON_KEY_BY_ZH[trimmed]
  if (key) return i18n.t(key)
  const macMatch = trimmed.match(MAC_MISMATCH_PATTERN) || trimmed.match(MAC_MISMATCH_PATTERN_ALT)
  if (macMatch) {
    return i18n.t('importFailReason.macMismatch', { ebikeId: macMatch[1] })
  }
  const uploadSizeMatch = trimmed.match(UPLOAD_FILE_SIZE_PATTERN)
  if (uploadSizeMatch) {
    return i18n.t('apiMessage.name149', {
      maxSize: uploadSizeMatch[1],
      currentSize: uploadSizeMatch[2],
    })
  }
  return message
}

export function isImportFailReason (message) {
  if (!message || typeof message !== 'string') return false
  const trimmed = normalizeImportFailReasonText(message)
  return Boolean(
    IMPORT_FAIL_REASON_KEY_BY_ZH[trimmed] ||
    MAC_MISMATCH_PATTERN.test(trimmed) ||
    MAC_MISMATCH_PATTERN_ALT.test(trimmed) ||
    UPLOAD_FILE_SIZE_PATTERN.test(trimmed),
  )
}
